export default function getFileContentAsBase64(fileUri) {
  return new Promise((resolve, reject) => {
    window.resolveLocalFileSystemURL(fileUri, resolve, reject);
  }).then(fileEntry => {
    return new Promise((resolve, reject) => {
      fileEntry.file(resolve, reject);
    });
  }).then(file => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = resolve;
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }).then(e => {
    return e.target.result;
  });
}